import React, { useEffect, useState } from 'react';
import { fetchArticles } from '../services/articles';
import ArticlesPreview from '../components/ArticlesPreview';
import styles from './Articles.module.css';

export default function Articles() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetchArticles().then(setArticles).catch(e => console.error(e));
  }, []);

  return (
    <div className="container">
      <h1>Videncenter</h1>
      <ArticlesPreview articles={articles} />
    </div>
  );
}
